<div #googleMapContainer
     class="google-map-wrapper">
</div>
<!-- <floating-menu [map]="map"></floating-menu> -->